import React from 'react';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Image from 'react-bootstrap/Image';
import LoadingGif from '../../../../static/images/loading.gif'

class UsernameFormView extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            ...props,
        };
    }
    
    render() {
        return (
            /* FIXME: OnSubmit, the info is showing up in the URL */
            <Form id="logonFormUsername" noValidate validated={this.props.isUsernameValid} onSubmit={this.props.handleFormSubmit}>
                <Form.Group id="logonUsernameGroup" className="relative">
                    {/* NOTE: The native HTML5 validation disabled using noValidate in Form tag
                    in order to disable native popup error*/}
                    <Form.Label className={`${this.props.floatLabel === true ? "absolute floating-label" : "absolute inline-label"}
                                              ${this.props.onFocus === true ? "label-black__TO" : ""}
                                              ${this.props.isUsernameValid === false && this.props.onFocus === false ? "label-red__TO" : ""}
                    
                    `} >Email or mobile number</Form.Label>
                    <Form.Control
                        required
                        id="logonUsername__TO"
                        data-testid="logonUsername"
                        aria-label="Username"
                        as="input"
                        type="text"
                        name="username"
                        placeholder=""
                        value={this.props.username}
                        onChange={this.props.handleUsernameChange}
                        onFocus={this.props.setFocus}
                        onBlur={this.props.onBlur}
                        bsPrefix={`${this.props.isUsernameValid === false && this.props.onFocus === false ? "highlight-error__TO" : ""} form-control`}
                    />
                    <div
                        id="usernameAlert"
                        data-testid="logonUsernameError"
                        className={`logon-item-error__TO ${this.props.isUsernameValid === false && this.props.onFocus === false ? "block" : "none"}`}
                        role="alert"
                        aria-hidden={`${this.props.isUsernameValid === false && this.props.onFocus === false ? "false" : "true"}`}
                    >
                        Please enter a valid email or mobile number.
                    </div>
                </Form.Group>
                <div className="username-button-grid" id={this.props.showAlert ? 'next-step' : 'next-step-disabled'}>
                    <Button id="logonButton" tabIndex={0} data-testid="logonButton" bsPrefix={`${this.props.isUsernameValid !== true ? "button-disabled__TO" : "button__TO "}`} type={`${this.props.isUsernameValid ? "submit" : ''}`} >Next Step</Button>
                </div>
                <Image data-testid="loadingGIF" className={`working ${this.props.loading ? "" : "none"}`} id="loadingGIF" src={LoadingGif} aria-hidden="true" />
            </Form>
        );
    }
}

export default UsernameFormView;